/**
 * Canonical list of compliance categories a project/organisation can track.
 * Keys must match `Project.trackingCategories` / `Organisation.trackingCategories`
 * on the backend (safework-api/src/models/Project.js and Organisation.js).
 *
 * Shared by the project creation modal (Projects.js) and the org onboarding
 * flow (OrgOnboardingModal.js / Settings.js) so both stay in sync.
 */
export const TRACKING_CATEGORIES = [
  { id: 'osh', label: 'Occupational Safety & Health', icon: 'fa-hard-hat', color: '#16a34a' },
  { id: 'environmental', label: 'Environmental Compliance', icon: 'fa-leaf', color: '#0891b2' },
  { id: 'labor', label: 'Labor & Working Conditions', icon: 'fa-users', color: '#3b82f6' },
  { id: 'stakeholder', label: 'Stakeholder Engagement', icon: 'fa-comments', color: '#8b5cf6' },
  { id: 'biodiversity', label: 'Biodiversity Conservation', icon: 'fa-tree', color: '#10b981' },
  { id: 'culturalHeritage', label: 'Cultural Heritage & Indigenous Peoples', icon: 'fa-landmark', color: '#f59e0b' },
  { id: 'gbvPrevention', label: 'GBV & SEA Prevention', icon: 'fa-shield-alt', color: '#ef4444' },
  { id: 'childLabor', label: 'Child Labor Prevention', icon: 'fa-child', color: '#dc2626' },
  { id: 'permits', label: 'Permits & Licenses', icon: 'fa-file-contract', color: '#84cc16' },
  { id: 'roadSafety', label: 'Road Safety', icon: 'fa-car-crash', color: '#f97316' },
];

// The handful of categories pre-selected for a brand new project/org that
// hasn't chosen anything yet - kept distinct from "onboarded with nothing
// selected" (an explicit, deliberate empty choice).
export const DEFAULT_TRACKING_CATEGORIES = {
  osh: true,
  environmental: true,
  labor: true,
  stakeholder: true,
  biodiversity: false,
  culturalHeritage: false,
  gbvPrevention: false,
  childLabor: false,
  permits: false,
  roadSafety: false,
};
